﻿import { createMiddleware } from 'redux-beacon';
import { addMiddleware } from 'redux-dynamic-middlewares';
import { SpeedcurveRum } from 'middlewares/speedcurveRum';
import getSpeedcurveEvent from 'services/speedcurveBuilder';
import SpeedcurveEventType from 'enums/speedcurveEvent';
import { speedCurveMarkEnd, speedCurveMarkStart, speedCurveTrackConversion, speedcurveTimingMetric } from './actions';

/**
 * The function `eventsMap` returns an event based on the action type and payload.
 * @param action - The `action` parameter is an object that represents an action being dispatched in a
 * Redux application. It typically has a `type` property that describes the type of action being
 * performed, and a `payload` property that contains any additional data associated with the action.
 * @returns The function `eventsMap` returns an event to be tracked.
 */
const eventsMap = (action) => {
  const payload = action.payload;

  switch (action.type) {
    case speedCurveTrackConversion.type:
      return getSpeedcurveEvent(SpeedcurveEventType.Conversion, payload);

    case speedCurveMarkStart.type:
      return getSpeedcurveEvent(SpeedcurveEventType.MarkStart, payload);

    case speedCurveMarkEnd.type:
      return getSpeedcurveEvent(SpeedcurveEventType.MarkEnd, payload);

    case speedcurveTimingMetric.type:
      return getSpeedcurveEvent(SpeedcurveEventType.TimingMetric, payload);

    default:
      return [];
  }
};

const speedcurveRum = new SpeedcurveRum();
const middleware = createMiddleware(eventsMap, speedcurveRum.getTarget());
addMiddleware(middleware);
